module.exports = __webpack_public_path__ + "img/lt-box1.d076b656.png";